import { createClient } from '@supabase/supabase-js';

const env = import.meta.env || {};
const url = String(env.VITE_SUPABASE_URL || '').trim();
const publishableKey = String(env.VITE_SUPABASE_PUBLISHABLE_KEY || '').trim();

function validSupabaseUrl(value) {
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' && /^[a-z0-9-]+\.supabase\.co$/i.test(parsed.hostname);
  } catch { return false; }
}
function looksSecret(value) {
  return /service[_-]?role/i.test(value) || /^sb_secret_/i.test(value);
}

export const hasSupabaseConfig = Boolean(validSupabaseUrl(url) && publishableKey && !looksSecret(publishableKey));

// createClient needs syntactically valid values even when deployment config is absent.
// These inert placeholders keep the module importable; AuthGate blocks all use until
// valid public frontend variables are supplied by the deployment environment.
const clientUrl = hasSupabaseConfig ? url : 'https://missing-config.invalid';
const clientKey = hasSupabaseConfig ? publishableKey : 'missing-publishable-key';

export const supabase = createClient(clientUrl, clientKey, {
  auth: {
    persistSession: typeof window !== 'undefined',
    autoRefreshToken: typeof window !== 'undefined',
    detectSessionInUrl: typeof window !== 'undefined',
  },
  global: {
    headers: { 'X-Client-Info': 'stock-critter-react-v5.68' },
  },
});

export const supabaseConfig = Object.freeze({
  projectRef: hasSupabaseConfig ? new URL(url).hostname.split('.')[0] : null,
  keyType: 'publishable',
  configured: hasSupabaseConfig,
});
